import Vue from 'vue'
import Vuex from 'vuex'
import Account from './modules/Account'
import Layout from './modules/Layout'
Vue.use(Vuex)
export default new Vuex.Store({
  modules: {
    account: Account,
    layout: Layout,
  }
})
